import React, {useEffect, useState} from 'react';
import { Button, Modal, Image, Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { store } from 'react-notifications-component';
import { Bounce } from "react-activity";
import Backend from '../../../../Backend';
import Connection from '../../../../Calls';
import SalirIcon from '../../../../Images/salir.svg'
import FormatMoney from '../../../../Helpers/formatMoney';
import './modalRise.css';


const ModalRise = (props) => {
  const [ammount, setAmmount] = useState('')
  const [reason, setReason] = useState('')
  const [sendRequest, setSendRequest] = useState(false);
  const [load, setLoad] = useState(false);

  const handleRiseSendRequest = () => {
    setLoad(true)
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.RequestRiseLimit(localStorage.getItem('email'), localStorage.getItem('token'),props.currentCard.id, ammount, reason, response.payload.r01, response => {
        if(response.status.code === '0'){
          setSendRequest(true); 
          props.hiddenModalRise(false)
          setLoad(false);
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }

          });
          setLoad(false)
        }
      })
    })
  }

  return(
    <>
      <Modal
        id="modal_rise"
        size="small"
        show={props.show}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header  style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
          <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
            <Image src={SalirIcon} onClick={() => {props.hiddenModalRise(false); setAmmount('') }} alt="X" style={{cursor: 'pointer'}}/>
          </div>
          <span className='title-rise-modal'>{props.traductions.Card.riseLimit.title}</span>
        </Modal.Header>
        <Modal.Body className='responsive-body'>
          <Form.Group>
            <Form.Label className='responsive-label'>{props.traductions.Card.riseLimit.label_ammount}</Form.Label>
            <NumberFormat
              className='amount-input-rise'
              placeholder={props.traductions.Card.riseLimit.placeholder_amount}
              decimalScale={2}
              thousandSeparator={true}
              prefix={'$'}
              style={{paddingLeft: '10px'}}
              suffix={' USD'}
              value={ammount}
              onValueChange={(values) => {const {value} = values; setAmmount(value)}}
            />
            <span className='legend-approx'>{props.traductions.Card.riseLimit.calculated_amount} {FormatMoney(ammount * props.market_price)} MXN</span>
          </Form.Group>
          <Form.Group>
            <Form.Label className='responsive-label'>{props.traductions.Card.riseLimit.label_reason}</Form.Label>
            <Form.Control maxLength={250} as="textarea" id='reason-rise' style={{height: '150px'}} onChange={(e) => setReason(e.target.value)}/>
            <div style={{textAlign: 'end'}}>
              <span className='characters'>{props.traductions.Card.riseLimit.count_characters}</span>
            </div>
          </Form.Group>
          <div style={{textAlign: 'center'}}>
            <Button disabled={ammount === ''|| reason === ''} className='send-rise-btn' onClick={handleRiseSendRequest}>
              { load ? 
                <Bounce
                  size={20}
                  color={"#FFFFFF"}
                  animating={load}
                />
                  : 
                props.traductions.Card.riseLimit.btn_send_request
              }
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        id="modal_rise_confirm"
        className='modal_rise_confirm'
        size="sm"
        show={sendRequest}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Body>
          <div style={{textAlign: 'center', marginTop: '24px', marginBottom: '14px'}}>
            <span className='title-rise-modal-confirm'>{props.traductions.Card.riseLimit.modal_confirm}</span>
          </div>

        <div style={{textAlign: 'center', marginBottom: '40px'}}>
          <span className='msg-rise-confirm' style={{whiteSpace: 'pre-line'}}>{props.traductions.Card.riseLimit.msg_confirm}</span>
        </div>
        <div style={{textAlign: 'center', marginBottom: '30px'}}>
          <Button className='send-rise-btn' onClick={() => {setSendRequest(false); setAmmount('')}} >{props.traductions.Card.riseLimit.btn_close}</Button>
        </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ModalRise;